"use strict";

angular.module("licensure.services").factory("EXSessionStatus", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSessionStatus", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getsessionstatus: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSessionStatus/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function(session_status) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/EXSessionStatus/";
                if (!isUndefined(session_status.id)) {
                    method = "PUT";
                    url += session_status.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        session_status: session_status
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/EXSessionStatus/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
